import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=2c0c7da4&scoped=true&"
import script from "./Empty.vue?vue&type=script&lang=ts&"
export * from "./Empty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c7da4",
  null
  
)

export default component.exports